import * as translationsKeys from './locale/translationsKeys';
import * as translations from './locale';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

export type TranslationKey = keyof typeof translationsKeys;
export type TranslateFunction = (key: TranslationKey | [string, TranslationKey] | string, options?: any) => string;

export const translate: TranslateFunction = (key, options?) => {
    return i18n.t(key, options);
};

export function initializeTranslations() {
    i18n.use(LanguageDetector)
        .init({
            detection: {
                order: [/*'localStorage', */'navigator'],
                caches: [],
            },
            fallbackLng: 'en',
            // uncomment to make language detection and switching work
            supportedLngs: ['en', /*'cs', 'sk', 'de'*/],
            returnEmptyString: false,
            resources: translations,
            interpolation: {
                escapeValue: false,
            },
        },
            (err) => {
                if (err) return console.error('i18n: something went wrong loading', err);
            }
        )
        /*.then(() => console.log('i18next test:', translate('ttsLearnMoreHeading')))*/;
}